module.exports = __webpack_public_path__ + "img/unstart.3787469e.png";